export default __webpack_public_path__ + "static/media/prayer_times.cfa16e48.png";